import * as Api from "utils/api/api";
import * as logger from "utils/logger.function";
import {TaskData} from "types/task";

export async function checkForUnevaluatedLines(tasksData: TaskData[] | null | undefined) {
    if (!tasksData || tasksData.length === 0) {
        return false;
    }

    const firstTask = tasksData[0];

    try {
        const result = await Api.getLineApprovalByUID(firstTask.uid);
        if (result.hasLinesNotEvaluated || result.rejectedLines) {
            return true;
        } else {
            const remainingTasks = tasksData.slice(1);
            if (remainingTasks.length > 0) {
                return checkForUnevaluatedLines(remainingTasks);
            }
            return false;
        }


    } catch (error) {
        logger.error("redux.processUnevaluatedLines", error);
        return false;
    }
}